// This file is automatically generated. Do not edit it directly.
import { createClient as supabaseCreateClient } from '@supabase/supabase-js';
import { Database } from './types';

// Use environment variables from .env file
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validate required environment variables
if (!SUPABASE_URL) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable. Please check your .env file.');
}

if (!SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable. Please check your .env file.');
}

// Validate URL format
try {
  new URL(SUPABASE_URL);
} catch (error) {
  throw new Error('Invalid VITE_SUPABASE_URL format. Please provide a valid URL.');
}

// Validate key format (should start with 'ey' for JWT)
if (!SUPABASE_PUBLISHABLE_KEY.startsWith('ey')) {
  throw new Error('Invalid VITE_SUPABASE_ANON_KEY format. Please provide a valid Supabase anon key.');
}

/**
 * Creates a type-safe Supabase client with the project's Database type
 * This is exported for backward compatibility
 */
export function createClient() {
  return supabaseCreateClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storageKey: 'supabase.auth.token',
      storage: window.localStorage, // Explicitly use localStorage
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce' // Use PKCE flow for better security
    }
  });
}

// Export a singleton instance for use throughout the app
export const supabase = createClient();

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";